import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "./axiosBaseQuery";

export const REPORTS_API_REDUCER_KEY = "reportsApi";

export const reportsApi = createApi({
  reducerPath: REPORTS_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["reports"],
  endpoints: (builder) => ({
    getReports: builder.query({
      query: ({ page, limit }) => {
        return {
          url: `reports/?page=${page}&limit=${limit}&sort=-created_at`,
        };
      },
      providesTags: ["reports"],
    }),

    getReport: builder.query({
      query: (id) => {
        if (!id) {
          return;
        }
        return {
          url: `reports/${id}/`,
        };
      },
      providesTags: ["reports"],
    }),
    getReportItems: builder.query({
      query: (reportId) => {
        if (!reportId) {
          return;
        }
        return {
          url: `reports/${reportId}/report-item/?limit=50`,
        };
      },
      providesTags: ["reports"],
    }),
    getReportItemHistory: builder.query({
      query: ({ reportId }) => {
        if (!reportId) {
          return;
        }
        return {
          url: `reports/${reportId}/report-item-history/`,
        };
      },
      providesTags: ["reports"],
    }),
    addReportItem: builder.mutation({
      query: ({ reportId, payload }) => {
        return {
          url: `reports/${reportId}/report-item/upsert/`,
          method: "POST",
          body: payload,
        };
      },
      invalidatesTags: ["reports"],
    }),
    createReport: builder.mutation({
      query: (body) => ({
        url: `reports/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["reports"],
    }),
    updateReport: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `reports/${id}/`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["reports"],
    }),

    deleteReport: builder.mutation({
      query: (id) => ({
        url: `reports/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["reports"],
    }),

    getCustomReports: builder.query({
      query: ({ page, limit }) => {
        return {
          url: `reports/custom-reports/?page=${page}&limit=${limit}`,
        };
      },
      providesTags: ["reports"],
    }),
    createCustomReport: builder.mutation({
      query: (body) => ({
        url: `reports/custom-reports/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["reports"],
    }),
    deleteCustomReport: builder.mutation({
      query: (id) => ({
        url: `reports/custom-reports/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["reports"],
    }),
    getEmbodiedReportConfigs: builder.query({
      query: () => ({
        url: `/reports/product-categories/`,
      }),
      providesTags: ["configs"],
    }),
    createEmbodiedReportConfig: builder.mutation({
      query: (body) => ({
        url: `/reports/product-categories/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["configs"],
    }),
    getActivitesForEmbReport: builder.query({
      query: () => ({
        url: `/reports/distinct-activity-names/`,
      }),
    }),
    getEmbodiedReport: builder.mutation({
      query: (body) => ({
        url: `/reports/embodied_report/`,
        method: "POST",
        body,
      }),
    }),
    getEmbodiedReportJson: builder.query({
      query: ({ organization_taxonomy, start_date, end_date, config_id }) => ({
        url: "/reports/embodied_report_json/",
        params: {
          organization_taxonomy,
          start_date,
          end_date,
          config_id,
        },
      }),
    }),
  }),
});

export const {
  useCreateReportMutation,
  useDeleteReportMutation,
  useGetReportQuery,
  useGetReportsQuery,
  useCreateCustomReportMutation,
  useGetCustomReportsQuery,
  useDeleteCustomReportMutation,
  useGetReportItemsQuery,
  useAddReportItemMutation,
  useGetReportItemHistoryQuery,
  useGetEmbodiedReportConfigsQuery,
  useGetActivitesForEmbReportQuery,
  useCreateEmbodiedReportConfigMutation,
  useGetEmbodiedReportMutation,
  useGetEmbodiedReportJsonQuery,
} = reportsApi;
